<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartImage :src="balance.user.avatar_url" size="md" />
		<LayoutTableCommonPartText :text="balance.user.name" :subtext="balance.user.email" :header="`Desde ${dateFormatted}`" />
		<LayoutTableCommonPartRaw class="text-end px-2">
			<span class="badge rounded-pill bg-success text-xs" v-if="balance.amount > 0">{{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</span>
			<span class="badge rounded-pill bg-warning text-xs" v-else>{{ vueNumberFormat(balance.amount, { suffix: ` ${balance.currency}`, precision: 2 }) }}</span>
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.balance.show', params: { id: balance.id }}" class="dropdown-item rounded-0">Detalle</router-link>
				<a href="javascript:void(0);" class="dropdown-item rounded-0" @click="pay" v-if="balance.amount > 0">Registrar pago</a>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		emits: ['pay'],
		props: {
			balance: Object
		},
		setup(props, { emit }) {
			const dateFormatted = computed(() => moment(props.balance.user.created_at).format('DD/MM/YYYY'));
			const pay = () => emit('pay', props.balance);

			return { dateFormatted, pay };
		}
	}
</script>